export function init(): void {
	import('./view')
		.then(mod => new mod.ClientUserListView({root: document.getElementById('pb-main')}));
}
